import React from "react"
import Icon from "../Icon/Icon"

import "./back-button.scss"

const BackButton = ({ href, title }) => {
  return (
    <a href={href} className="f-back-button">
      <Icon icon="icon-arrow-left white" size="3" tagtype="span" />
      <p>{title ? title : "VOLVER AL INICIO"} </p>
    </a>
  )
}

export default BackButton
